import { randomString } from '@/utils'
import { Room } from './PersonSelector.types'

export const MAX_PERSONS_PER_ROOM = 4

export const defaultChildAge = { label: '<1', value: 0 }

export const initialRoom = (adults = 2): Room => ({
  id: randomString(5),
  adults,
  children: 0,
  childrenAges: [],
  dropdownOpen: [],
})

export const ageOptions = Array.from({ length: 12 }, (_, i) => ({
  label: i ? i.toString() : '<1',
  value: i,
}))
